module.exports = __webpack_public_path__ + "static/dior-560ac32d2cb7ec828c39f05ebf548092.png";